// Copyright 2021 Sorama B.V.

import { autoinject } from "aurelia-framework";
import { NavigationInstruction, Next, PipelineStep, Redirect } from "aurelia-router";
import { ILicenseService } from "./ILicenseService";

@autoinject
export class LicenseCheckStep implements PipelineStep {
    constructor(private readonly licenseService: ILicenseService) {}

    public async run(instruction: NavigationInstruction, next: Next): Promise<unknown> {
        if (!instruction.config || !instruction.config.settings || !instruction.config.settings.licenseCheck) {
            // No check required
            return next();
        }

        const license = await this.licenseService.getActiveMembershipLicense();
        let licenseValid = false;

        if (typeof instruction.config.settings.licenseCheck === "boolean") {
            licenseValid = !!license;
        } else {
            licenseValid = instruction.config.settings.licenseCheck(license);
        }

        if (licenseValid) {
            return next();
        } else {
            return next.cancel(new Redirect("/invalidmembership"));
        }
    }
}
